import { useMemo } from 'react';
import appConfig from '@frontend/env';
import {
  PaymentConfigName,
  paymentMethodConfigurations,
  StripeConfigLocationType,
  UsePaymentMethodConfigOptions,
} from '@frontend/payments-stripe-wrapper';
import { UseProcessorData } from '../use-processor-data';

interface useLoadStripeConfigProps {
  paymentConfigName?: PaymentConfigName;
  isPublic: boolean;
  locationData: UseProcessorData['locationData'];
}

export const useLoadStripeConfig = ({ paymentConfigName, isPublic, locationData }: useLoadStripeConfigProps) => {
  const locationType =
    locationData?.opsType !== 'REGULAR' ? StripeConfigLocationType.Dev : StripeConfigLocationType.Prod;

  const paymentMethodConfig = useMemo(() => {
    return !isPublic
      ? getPaymentMethodConfigAuthenticated({ paymentConfigName, locationType })
      : getPaymentMethodConfigPublic({ paymentConfigName, locationType });
  }, [isPublic, paymentConfigName, locationType]);

  return paymentMethodConfig;
};

export const getPaymentMethodConfigPublic = (_props: UsePaymentMethodConfigOptions) => {
  console.warn('TODO: getPaymentMethodConfigPublic needs actual implementation, or to be removed');
  return Math.round(Math.random()) === 1 ? '' : undefined;
};

export const getPaymentMethodConfigAuthenticated = ({
  paymentConfigName,
  locationType,
}: UsePaymentMethodConfigOptions) => {
  const envType =
    locationType ??
    (!!appConfig?.PAY_BACKEND_API?.includes('weavedev') ? StripeConfigLocationType.Dev : StripeConfigLocationType.Prod);
  return paymentConfigName && paymentMethodConfigurations[paymentConfigName]?.[envType];
};
